import type { FormikHelpers } from 'formik';
import * as apiObject from 'api/apiObjects';
import type { HistoryPriceFormValues } from './types';

type TranslateFn = (key: string) => string;
type ShowToastFn = (message: string, type: 'success' | 'danger') => void;

export interface SubmitHistoryPriceParams {
    objectId: number;
    t: TranslateFn;
    showToast: ShowToastFn;
    onSuccess: (objectPrice: number, objectPriceRate: number) => Promise<void>;
}

export const submitHistoryPrice = async (
    values: HistoryPriceFormValues,
    helpers: FormikHelpers<HistoryPriceFormValues>,
    params: SubmitHistoryPriceParams,
): Promise<void> => {
    const { objectId, t, showToast, onSuccess } = params;
    const { setSubmitting, setFieldError } = helpers;

    setSubmitting(true);
    try {
        const res = await apiObject.setObjectPrice(objectId, {
            objectPrice: Number(values.objectPrice) || 0,
            objectPriceRate: Number(values.objectPriceRate) || 0,
            comment: String(values.comment || ''),
        });

        if (res?.stat) {
            await onSuccess(
                Number(res.objectPrice ?? values.objectPrice) || 0,
                Number(res.objectPriceRate ?? values.objectPriceRate) || 0,
            );
            showToast(t('historyPrice.messChanged'), 'success');
            return;
        }

        if (res?.errCode === 'PRICE_UNCHANGED') {
            setFieldError('objectPrice', t('historyPrice.errUnchanged'));
            return;
        }

        if (res?.errCode === 'OBJECT_LOCKED') {
            showToast(t('historyPrice.errLocked'), 'danger');
            return;
        }

        showToast(t('common:messError'), 'danger');
    } finally {
        setSubmitting(false);
    }
};
